module.exports = __webpack_public_path__ + "img/0Q3A2365_FoamcoreMatted.cb7acc63.jpg";